import { render, staticRenderFns } from "./SupplierModal.vue?vue&type=template&id=f6473ea4&scoped=true&"
import script from "./SupplierModal.vue?vue&type=script&lang=js&"
export * from "./SupplierModal.vue?vue&type=script&lang=js&"
import style0 from "./SupplierModal.vue?vue&type=style&index=0&id=f6473ea4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6473ea4",
  null
  
)

export default component.exports